// extracted by mini-css-extract-plugin
export default {"paper":"accessingFeatureMenu_paper__HOqJf","arrow":"accessingFeatureMenu_arrow__R9g7j","accessing_feature":"accessingFeatureMenu_accessing_feature__69wf7"};